import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import { SupabaseGetFeedbackDetailRepository } from '@/modules/feedback/infra'
import type { GetFeedbackDetail } from '@/modules/feedback/use-cases'

export function makeGetFeedbackDetail(): GetFeedbackDetail {
  return new SupabaseGetFeedbackDetailRepository(makeSupabaseEdgeHttpClient()).execute
}
